import React from 'react';
import { Helmet } from 'react-helmet';
import { FaPhone, FaEnvelope, FaHome } from 'react-icons/fa';

function Contact() {
  const [formData, setFormData] = React.useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  });
  const [showModal, setShowModal] = React.useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowModal(true);
    setFormData({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      message: ''
    });
  };

  return (
    <>
      <Helmet>
        <title>Επικοινωνία με το Nalumer | Catering Ελλάδα</title>
        <meta name="description" content="Επικοινωνήστε με το Nalumer για προσφορά catering. Σχεδιάζουμε γάμους, εταιρικά events και ιδιωτικές εκδηλώσεις. Καλέστε μας ή στείλτε μήνυμα σήμερα." />
        <meta property="og:title" content="Επικοινωνία με το Nalumer | Catering Ελλάδα" />
        <meta property="og:description" content="Επικοινωνήστε με το Nalumer για προσφορά catering. Σχεδιάζουμε γάμους, εταιρικά events και ιδιωτικές εκδηλώσεις. Καλέστε μας ή στείλτε μήνυμα σήμερα." />
        <link rel="canonical" href="https://nalumer.com/contact" />
      </Helmet>

      <div className="contact-container">
        <div className="contact-header">
          <h1>Επικοινωνήστε Μαζί Μας</h1>
          <p>Είμαστε εδώ για να απαντήσουμε στις ερωτήσεις σας και να σχεδιάσουμε μαζί την τέλεια εκδήλωσή σας</p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <h2>Στοιχεία Επικοινωνίας</h2>
            
            <div className="contact-item">
              <div className="contact-icon">
                <FaHome />
              </div>
              <div className="contact-item-content">
                <h3>Διεύθυνση</h3>
                <p>Λεωφόρος Παπανικολάου, 99</p>
                <p>36508, Προσοτσάνη, Ελλάδα</p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <FaPhone />
              </div>
              <div className="contact-item-content">
                <h3>Τηλέφωνο</h3>
                <p>+59955812136</p>
                <p>Δευτέρα - Παρασκευή: 09:00 - 18:00</p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <FaEnvelope />
              </div>
              <div className="contact-item-content">
                <h3>Email</h3>
                <p><a href="mailto:nalumer@hotmail.com">nalumer@hotmail.com</a></p>
                <p>Απαντάμε εντός 24 ωρών</p>
              </div>
            </div>

           
          </div>

          <div className="contact-form-wrapper">
            <h2>Στείλτε μας Μήνυμα</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="firstName">Όνομα *</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="lastName">Επώνυμο *</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Τηλέφωνο *</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Μήνυμα *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>

              <button type="submit" className="submit-btn">
                Αποστολή Μηνύματος
              </button>
            </form>
          </div>
        </div>

        <div className="company-info">
          <h2>Nalumer - Υπηρεσία Catering</h2>
          <p>Αριθμός Μητρώου Εταιρείας: 42936013</p>
          <p>ΑΦΜ: EL42936013</p>
          <p>Λειτουργούμε με πλήρη άδεια από την Ελληνική Αρχή Τροφίμων</p>
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Ευχαριστούμε!</h3>
            <p>Το μήνυμά σας έχει σταλεί επιτυχώς. Θα επικοινωνήσουμε μαζί σας το συντομότερο δυνατό.</p>
            <button onClick={() => setShowModal(false)} className="modal-close-btn">
              Κλείσιμο
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default Contact;